import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject } from '@angular/core';
import { zxcvbnOptions, zxcvbn, zxcvbnAsync } from '@zxcvbn-ts/core';
import { translations } from '@zxcvbn-ts/language-en';
import { IPasswordStrengthMeterService } from 'angular-password-strength-meter';

const ZXCVBN_CONFIG = new InjectionToken('ZXCVBN_CONFIG');

const DEFAULT_CONFIG = {
    translations: translations,
};
class PasswordStrengthMeterZXCVBNService extends IPasswordStrengthMeterService {
    constructor(options) {
        super();
        if (options) {
            zxcvbnOptions.setOptions(options);
        }
        else {
            zxcvbnOptions.setOptions(DEFAULT_CONFIG);
        }
    }
    /**
     *  this will return the password strength score in number
     *  0 - too guessable
     *  1 - very guessable
     *  2 - somewhat guessable
     *  3 - safely unguessable
     *  4 - very unguessable
     *
     *  @param password - Password
     */
    score(password) {
        const result = zxcvbn(password);
        return result.score;
    }
    /**
     * this will return the password strength score with feedback messages
     * return type { score: number; feedback: { suggestions: string[]; warning: string } }
     *
     * @param password - Password
     */
    scoreWithFeedback(password) {
        const result = zxcvbn(password);
        return { score: result.score, feedback: result.feedback };
    }
    async scoreAsync(password) {
        const result = await zxcvbnAsync(password);
        return result.score;
    }
    async scoreWithFeedbackAsync(password) {
        const result = await zxcvbnAsync(password);
        return { score: result.score, feedback: result.feedback };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PasswordStrengthMeterZXCVBNService, deps: [{ token: ZXCVBN_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PasswordStrengthMeterZXCVBNService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PasswordStrengthMeterZXCVBNService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [ZXCVBN_CONFIG]
                }] }]; } });

const DEFAULT_PSM_OPTIONS = {
    serviceClass: PasswordStrengthMeterZXCVBNService,
};

/* Public API Surface of password-strength-meter default zxcvbn service
*/

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_PSM_OPTIONS, ZXCVBN_CONFIG };
